.product-market-field-array {
    overflow-y: auto;
}

.product-market-field-array:has(> :nth-child(2)) {
    height: 400px;
}

.save-button-container {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
}
